module.exports = __webpack_public_path__ + "img/Done_rd_blue_70@2x.e1ce7c17.png";